import React, { useContext } from 'react';
import { Layout, Menu } from 'antd';
import { ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { UserOutlined, ContactsOutlined, CloudServerOutlined } from '@ant-design/icons';
import Header from './Header';
import { Store } from '../store';
import languages from '../constants/languages';
const { Content, Sider } = Layout;

const MainLayout = props => {
    const { state } = useContext(Store);
    const [initActiveMenu, setInitActiveMenu] = React.useState(null);
    React.useEffect(() => {
        const currentUrl = window.location.pathname;
        const key = currentUrl.includes('contact') ? 2 : currentUrl.includes('user') ? 3 : 1;
        setInitActiveMenu(key.toString());
    }, []);

    if(!initActiveMenu){
        return <div>Loading...</div>
    }

    return (
        <Layout className="layout-home">
            <Sider
                breakpoint="lg"
                collapsedWidth="0"
            >
                <div className="logo" />
                <Menu theme="dark" mode="inline" defaultSelectedKeys={[initActiveMenu]}>
                    <Menu.Item key="1" icon={<CloudServerOutlined />}>
                        <Link to="/server/list">サーバー一覧</Link>
                    </Menu.Item>
                    <Menu.Item key="2" icon={<ContactsOutlined />}>
                        <Link to="/contact/list">連絡先</Link>
                    </Menu.Item>
                    {
                        state.session.is_admin && (
                            <Menu.Item key="3" icon={<UserOutlined />}>
                                <Link to="/user/list">{languages.menuUser}</Link>
                            </Menu.Item>
                        )
                    }
                </Menu>
            </Sider>
            <Layout>
                <Header />
                <Content className="layout-main-content">
                    {props.children}
                </Content>
            </Layout>
            <ToastContainer />
        </Layout>            
    );
};

export default MainLayout;